import React, { useEffect, useState, useMemo, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Header/AppHeader';
import moment from 'moment';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../QuotationRecords/QuotationStyle.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import DataExport from '../Common/Export';
import DataTable from '../Common/DataTableList';

const IServRecords = () => {

    const { CurrentTheme } = useContext(ThemeContext);

    const [DeliveryData, setDeliveryData] = useState([]);
    const [SelectedOption, setSelectedOption] = useState(-1);

    useEffect(() => {
        //FetchDeliverys();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const Failure = (err) => {
        FailureAlert(err);
    };

    const DeliveryDataSuccess = (data) => {
        if (data.length > 0) {
            setDeliveryData(data);
        }
        else {
            setDeliveryData([]);
        }
    };

    const FetchDeliverys = (status) => {
        Axiosfetch(baseURL + "GetActiveIntServDlvrByStatus", "POST", {
            Status: status
        }, DeliveryDataSuccess, Failure);
    };

    const columns = [
        {
            name: 'Job ID',
            width: "155px",
            selector: row => <h6>{`${row.JobID}_${moment(row.createdAt).local().format("DDMMYYYY")}`}</h6>,
            sortable: true,
        },
        {
            name: 'Source-Destination',
            width: "220px",
            selector: row => `${row.OriginCity} - ${row.DestCity}`,
            sortable: true,
        },
        {
            name: 'Request By',
            width: "250px",
            selector: (row) => {
                return <div className="p-2" style={{ flex: "2" }}>
                    <h6>MFI {row.Organization[0].City}</h6>
                    <div>{row.Organization[0].Name}</div>
                    <div>Ph No. : {row.Organization[0].Contact}</div>
                </div>
            }
        },
        {
            name: 'Request To',
            width: "250px",
            selector: (row) => {
                return <div className="p-2" style={{ flex: "2" }}>
                    <h6>MFI {row.DestOrganization[0].City}</h6>
                    <div>{row.DestOrganization[0].Name}</div>
                    <div>Ph No. : {row.DestOrganization[0].Contact}</div>
                </div>
            }
        },
        {
            name: 'Status',
            selector: row => row.Status === 2 ? <span style={{ color: "orange" }}>In progress</span> :
                (row.Status === 3 ? <span style={{ color: "green" }}>Completed</span> :
                    (row.Status === 0 ? <span style={{ color: "red" }}>Discarded</span> :
                        <span style={{ color: "red" }}>No Action</span>)),
            sortable: true,
        },
        {
            name: 'Created Date',
            width: "200px",
            selector: row => moment(row.CreatedAt).local().format("DD/MM/YYYY hh:mm:ss A"),
        }
    ];

    const OnDlvrStatus = (selectedValue) => {
        setSelectedOption(selectedValue);
        if (selectedValue >= 0) {
            FetchDeliverys(selectedValue);
        }
        else {
            setDeliveryData([]);
        }
    }

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-4 col-md-4 col-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Delivery Records</h5>
                    </div>
                    <div className={`${parseInt(process.env.REACT_APP_EXPORT_REQUIRED) === 1 ? "col-md-3 col-10 align-right" : "col-md-4 col-10 align-right"}`}>
                        <div className="basic-select">
                            <select className="DropdownStyle" value={SelectedOption} onChange={(e) => OnDlvrStatus(parseInt(e.target.value))}>
                                <option value="-1">Select Option</option>
                                <option value="0">Discarded</option>
                                <option value="1">No Action</option>
                                <option value="2">Approved</option>
                                <option value="3">Completed</option>
                            </select>
                        </div>
                    </div>
                    {/* {parseInt(process.env.REACT_APP_EXPORT_REQUIRED) === 1 && (<div className="col-md-1 col-2 align-left">
                        <span data-tip="Export Quotation" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={exportToCSV}>
                            <FontAwesomeIcon icon={faFileExcel} />
                        </span>
                    </div>)} */}
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <DataTable columns={columns} data={DeliveryData}></DataTable>
                </div>
            </div>
        </div>
    );
};

export default IServRecords;